
import Hls from "./Previews/Hls.vue";
import Iframe from "./Previews/Iframe.vue";
export default {
  components: {
    Hls,
    Iframe,
  },
  props: {
    video: {
      type: Object,
      required: true,
    },
    isActionVisible: {
      type: Boolean,
      default: false,
    },
  },
};
